import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.damage.annotate');
import { OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-damage-annotate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.damage.annotate/view.scss */
/* src/app/page.damage.annotate/view.scss: no such file or directory */`],
})
export class PageDamageAnnotateComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('annotCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;

    public imageId: string = '';
    public image: any = null;
    public annotations: any[] = [];
    public classNames: string[] = [];
    public selectedClass: string = '';

    // 드로잉 상태
    private ctx: CanvasRenderingContext2D | null = null;
    private drawing: boolean = false;
    private startX: number = 0;
    private startY: number = 0;
    private currentX: number = 0;
    private currentY: number = 0;
    private canvasImage: HTMLImageElement | null = null;

    // 네비게이션
    public imageIds: string[] = [];
    public currentIndex: number = -1;

    // 캔버스 크기
    public canvasWidth: number = 640;
    public canvasHeight: number = 480;

    // 라우터 구독 (페이지 터너용)
    private routerSub: any;

    // 동적 색상 팔레트
    private readonly HEX_PALETTE = [
        '#EF4444', '#F59E0B', '#8B5CF6', '#10B981', '#3B82F6',
        '#EC4899', '#F97316', '#14B8A6', '#84CC16', '#6366F1',
        '#F43F5E', '#0EA5E9', '#D946EF', '#22C55E', '#CA8A04'
    ];
    private readonly BG_PALETTE = [
        'bg-red-500', 'bg-amber-500', 'bg-violet-500', 'bg-emerald-500', 'bg-blue-500',
        'bg-pink-500', 'bg-orange-500', 'bg-teal-500', 'bg-lime-500', 'bg-indigo-500',
        'bg-rose-500', 'bg-sky-500', 'bg-fuchsia-500', 'bg-green-500', 'bg-yellow-500'
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.imageId = WizRoute.segment.id || '';
        if (!this.imageId) {
            this.service.href('/damage/images');
            return;
        }
        await this.loadImageList();
        await this.load();
        await this.service.render();

        // 페이지 터너: URL 파라미터 변경 감지 (Angular 컴포넌트 재사용 시 ngOnInit은 재호출 안 됨)
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id || '';
                if (newId && newId !== this.imageId) {
                    this.imageId = newId;
                    this.currentIndex = this.imageIds.indexOf(this.imageId);
                    await this.load();
                }
            }
        });
    }

    public ngAfterViewInit() {
        this.initCanvas();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private initCanvas() {
        if (!this.canvasRef) return;
        const canvas = this.canvasRef.nativeElement;
        this.ctx = canvas.getContext('2d');
        canvas.addEventListener('mousedown', this.onMouseDown.bind(this));
        canvas.addEventListener('mousemove', this.onMouseMove.bind(this));
        canvas.addEventListener('mouseup', this.onMouseUp.bind(this));
    }

    public async loadImageList() {
        const { code, data } = await wiz.call('image_list');
        if (code === 200) {
            this.imageIds = data.ids;
            this.currentIndex = this.imageIds.indexOf(this.imageId);
        }
    }

    public async load() {
        const { code, data } = await wiz.call('load', { id: this.imageId });
        if (code !== 200) {
            this.service.href('/damage/images');
            return;
        }
        this.image = data.image;
        this.annotations = data.annotations;
        this.classNames = data.class_names;
        if (this.classNames.length > 0 && !this.classNames.includes(this.selectedClass)) {
            this.selectedClass = this.classNames[0];
        }
        await this.loadImage();
        await this.service.render();
    }

    private async loadImage() {
        return new Promise<void>((resolve) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                this.canvasImage = img;
                this.redraw();
                resolve();
            };
            img.src = `/wiz/api/page.damage.annotate/image?id=${this.imageId}&t=${Date.now()}`;
        });
    }

    private redraw() {
        if (!this.ctx || !this.canvasImage) return;
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        ctx.drawImage(this.canvasImage, 0, 0, this.canvasWidth, this.canvasHeight);
        this.drawAnnotations();
    }

    private drawAnnotations() {
        if (!this.ctx) return;
        const ctx = this.ctx;

        for (const ann of this.annotations) {
            const [x1, y1, x2, y2] = ann.bbox;
            const color = this.getHexColor(ann.class_name);
            ctx.strokeStyle = color;
            ctx.lineWidth = 2;
            ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);

            const label = ann.class_name;
            ctx.font = '12px sans-serif';
            const metrics = ctx.measureText(label);
            ctx.fillStyle = color;
            ctx.fillRect(x1, y1 - 16, metrics.width + 8, 16);
            ctx.fillStyle = '#FFFFFF';
            ctx.fillText(label, x1 + 4, y1 - 4);
        }
    }

    // 마우스 이벤트
    private getCanvasPos(event: MouseEvent) {
        const canvas = this.canvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        return {
            x: Math.round((event.clientX - rect.left) * (this.canvasWidth / rect.width)),
            y: Math.round((event.clientY - rect.top) * (this.canvasHeight / rect.height))
        };
    }

    private onMouseDown(event: MouseEvent) {
        if (!this.selectedClass) return;
        const pos = this.getCanvasPos(event);
        this.drawing = true;
        this.startX = pos.x;
        this.startY = pos.y;
        this.currentX = pos.x;
        this.currentY = pos.y;
    }

    private onMouseMove(event: MouseEvent) {
        if (!this.drawing) return;
        const pos = this.getCanvasPos(event);
        this.currentX = pos.x;
        this.currentY = pos.y;

        this.redraw();
        if (this.ctx) {
            this.ctx.strokeStyle = '#00FF00';
            this.ctx.lineWidth = 1;
            this.ctx.setLineDash([4, 4]);
            this.ctx.strokeRect(this.startX, this.startY, this.currentX - this.startX, this.currentY - this.startY);
            this.ctx.setLineDash([]);
        }
    }

    private async onMouseUp(event: MouseEvent) {
        if (!this.drawing) return;
        this.drawing = false;
        const pos = this.getCanvasPos(event);

        const x1 = Math.min(this.startX, pos.x);
        const y1 = Math.min(this.startY, pos.y);
        const x2 = Math.max(this.startX, pos.x);
        const y2 = Math.max(this.startY, pos.y);

        if (x2 - x1 < 5 || y2 - y1 < 5) {
            this.redraw();
            return;
        }

        await this.addAnnotation(x1, y1, x2, y2);
    }

    private async addAnnotation(x1: number, y1: number, x2: number, y2: number) {
        const { code, data } = await wiz.call('add_annotation', {
            image_id: this.imageId,
            class_name: this.selectedClass,
            x1, y1, x2, y2
        });
        if (code === 200) {
            this.annotations.push(data.data);
            this.redraw();
            await this.service.render();
        }
    }

    public async deleteAnnotation(id: string) {
        await wiz.call('delete_annotation', { id });
        this.annotations = this.annotations.filter(a => a.id !== id);
        this.redraw();
        await this.service.render();
    }

    public async clearAnnotations() {
        const res = await this.service.modal.show({
            title: '초기화',
            message: '이 이미지의 모든 어노테이션을 삭제하시겠습니까?',
            action: '초기화',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;
        await wiz.call('clear_annotations', { image_id: this.imageId });
        this.annotations = [];
        this.redraw();
        await this.service.render();
    }

    public selectClass(cls: string) {
        this.selectedClass = cls;
    }

    // 네비게이션
    public goPrev() {
        if (this.currentIndex > 0) {
            const prevId = this.imageIds[this.currentIndex - 1];
            this.service.href(`/damage/annotate/${prevId}`);
        }
    }

    public goNext() {
        if (this.currentIndex < this.imageIds.length - 1) {
            const nextId = this.imageIds[this.currentIndex + 1];
            this.service.href(`/damage/annotate/${nextId}`);
        }
    }

    public goBack() {
        this.service.href('/damage/images');
    }

    // 동적 색상 메서드
    public getHexColor(cls: string): string {
        const i = this.classNames.indexOf(cls);
        if (i < 0) return '#9CA3AF';
        return this.HEX_PALETTE[i % this.HEX_PALETTE.length];
    }

    public getClassColor(cls: string): string {
        const i = this.classNames.indexOf(cls);
        if (i < 0) return 'bg-zinc-500';
        return this.BG_PALETTE[i % this.BG_PALETTE.length];
    }
}

export default PageDamageAnnotateComponent;